export const LIMIT_ACTIONS = {
    LOGOUT: 'logout',
    MESSAGE: 'message'
};

export const UNLIMITED_VALUE = '92233720368547758.07';
